import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "iletisim";
var iletisimService = {
    iletisimDetay(iletisimId) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                iletisimId: iletisimId,
                methodName: "iletisimDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimArsiv(iletisimId) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                iletisimId: iletisimId,
                methodName: "iletisimArsiv"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimList(durum, baslangic, limit) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                konuKodu: "",
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                methodName: "iletisimList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
};
export default iletisimService

